module.exports = __webpack_public_path__ + "06_short_black.285af381.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/06_short_black.png
// module id = oS1J
// module chunks = 0